module.exports = __webpack_public_path__ + "img/5-5.c2f73681.svg";